<div class="container">
    <div class="option">
        <div class="option-name subtitle5">Repeats:</div>
        <mat-form-field appearance="fill">
            <mat-select [(ngModel)]="timeFrame.repeatDuration">
                <mat-option *ngFor="let option of repeatOptions" [value]="option.repeatDuration"
                    (click)="setPluralVersion(option.pluralVersion)">
                    {{option.repeatDuration}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="option" *ngIf="timeFrame.repeatDuration != 'Monthly'">
        <div class="option-name subtitle5">Every:</div>
        <mat-form-field appearance="fill" class="every-field">
            <span class="number-wrapper">
                <input matInput type="number" min="1" [(ngModel)]="timeFrame.repeatInterval" (change)="validate(); handleClick('repeat-every-input', 'Repeat Every Input')">
            </span>
        </mat-form-field>
        <div class="plural-version subtitle5">{{pluralVersionSelected}}</div>
    </div>
    <div class="option" *ngIf="timeFrame.repeatDuration == 'Monthly'">
        <mat-radio-group [(ngModel)]="timeFrame.monthRepeatType" class="month-picker">
            <mat-radio-button class="month-option" [value]="0" [class.inactive]="timeFrame.monthRepeatType != 0" [checked]="timeFrame.monthRepeatType == 0" (click)="handleClick('set-month-repeat-day', 'Repeat On Day Of Month Selection')">
                <span class="subtitle5">Day</span>
                <mat-form-field appearance="fill" class="every-field">
                    <span class="number-wrapper">
                        <input matInput type="number" min="1" [(ngModel)]="timeFrame.repeatDayOfMonth" (change)="validate()">
                    </span>
                </mat-form-field>
                <span class="subtitle5">of every</span>
                <mat-form-field appearance="fill" class="every-field">
                    <span class="number-wrapper">
                        <input matInput type="number" min="1" [(ngModel)]="timeFrame.repeatInterval" (change)="validate()">
                    </span>
                </mat-form-field>
                <span class="subtitle5">months</span>
            </mat-radio-button>
            <mat-radio-button [value]="1" class="month-option" [class.inactive]="timeFrame.monthRepeatType != 1" [checked]="timeFrame.monthRepeatType == 1" (click)="handleClick('set-repeat-month-specific-day-of-week', 'Repeat Monthly On Day of Week Selection')">
                <span class="subtitle5">The</span>
                <mat-form-field appearance="fill" style="width: 80px;">
                    <mat-select [(ngModel)]="timeFrame.repeatWeekOfMonth">
                        <mat-option *ngFor="let option of repeatWeekOfMonthOptions" [value]="option.value">
                            {{option.display}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 130px;">
                    <mat-select [(ngModel)]="timeFrame.repeatDayOfWeek">
                        <mat-option *ngFor="let option of daysOfWeek" [value]="option.value">
                            {{option.full}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="subtitle5">of every</span>
                <mat-form-field appearance="fill" class="every-field">
                    <span class="number-wrapper">
                        <input matInput type="number" min="1" [(ngModel)]="timeFrame.repeatInterval" (change)="validate()">
                    </span>
                </mat-form-field>
                <span class="subtitle5">months</span>
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <div class="option dayPicker" *ngIf="timeFrame.repeatDuration == 'Weekly'">
        <div class="option-name subtitle5">On a:</div>
        <mat-radio-group class="radio-group">
            <mat-radio-button class="radio-button" *ngFor="let day of daysOfWeek" [value]="day.abbr" [checked]="timeFrame.repeatDayOfWeek == day.value"
                (change)="setRepeatDayOfWeek(day.value)">
                <span class="subtitle5"> {{day.abbr}}</span>
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <div class="option">
        <div class="option-name subtitle5">Start Date:</div>
        <mat-form-field appearance="fill">
            <mat-label>Choose a date</mat-label>
            <input matInput [matDatepicker]="picker" [min]="minDate" [(ngModel)]="timeFrame.startDate"
                (dateInput)="validate(); handleClick('set-start-date', 'Start Date Input')" >
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker (selectedChanged)="validate()" #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="end-date">
        <mat-radio-button class="option-name subtitle5" style="margin-right:16px" (click)="validate(); handleClick('set-no-end-date', 'No End Date Selection')"
            [checked]="timeFrame.endDate == null">
            No end date
        </mat-radio-button>
        <!-- <div class="end-date">
            <mat-radio-button (click)="changeEndDateType('after')">
                End after
            </mat-radio-button>
            <mat-form-field>
                <input matInput type="number" min="1" [(ngModel)]="timeFrame.endDateRepeatInterval"
                    (change)="validate()">
            </mat-form-field>
            <div class="plural-version">occurences</div>
        </div> -->
        <div>
            <mat-radio-button (click)="validate()" [checked]="timeFrame.endDate != null">
                <span class="option-name subtitle5">End by:</span>
            </mat-radio-button>
            <mat-form-field appearance="fill">
                <mat-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="endByPicker" [min]="minDate" [(ngModel)]="timeFrame.endDate"
                    (dateInput)="validate(); handleClick('set-end-date', 'End Date Input')">
                <mat-datepicker-toggle matSuffix [for]="endByPicker"></mat-datepicker-toggle>
                <mat-datepicker #endByPicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
</div>